import React from 'react';

export const ForemanIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M15.0002 12L6.62718 20.373C6.22935 20.7708 5.68979 20.9943 5.12718 20.9943C4.56457 20.9943 4.025 20.7708 3.62718 20.373C3.22936 19.9752 3.00586 19.4356 3.00586 18.873C3.00586 18.3104 3.22936 17.7708 3.62718 17.373L12.0002 9M18.0002 15L22.0002 11"
                stroke="#00AEEF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.5 11.5009L19.586 9.58694C19.2109 9.21195 19.0001 8.70333 19 8.17294V7.00094L16.74 4.74094C15.6245 3.62612 14.115 2.9953 12.538 2.98494L9 2.96094L9.92 3.78094C10.5735 4.36033 11.0967 5.07164 11.4552 5.86798C11.8137 6.66432 11.9994 7.52761 12 8.40094V10.0009L14 12.0009H15.172C15.7024 12.0011 16.211 12.2118 16.586 12.5869L18.5 14.5009"
                stroke="#00AEEF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
